define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/comm/Aspera",
	"csi/comm/GetRequest",
	"csi/comm/PostRequest"
], function(declare,csi,Controller,Aspera,GetRequest,PostRequest) {

	const QUALITY_MODULE = "Quality";

	return declare(Controller, {
		toWriter: function() {
			if (Aspera.isEnabled()) {
				let transferSpec = null;
				let request = new GetRequest(QUALITY_MODULE, "DownloadContractualDocumentPackageZipAspera")
					.addParameter("URL", this.m_urlNode)
					.get({handleAs: "json"}).then(
						(response) => {
							transferSpec = response.data;
							return Aspera.downloadFileFromSpec(transferSpec);
						}
					).then(
						function() {
							if (transferSpec) {
								let deleteRequest = new PostRequest(QUALITY_MODULE, "DeleteDataPackageZip");
								deleteRequest.addParameter("FileName", transferSpec.transfer_specs[0].transfer_spec.paths[0].destination);
								return deleteRequest.post();
							} else {
								return null;
							}
						}
					).then(
						(msg) => {
							this.postProcess();
						}
					);
			} else {
				let request = new GetRequest(QUALITY_MODULE, "DownloadContractualDocumentPackageZip")
					.addParameter("URL", this.m_urlNode);

				csi.browserWindow(request.toRequest(), QUALITY_MODULE);
			}
        }
    });
});